import constants from "../Utils/constants";
const initialState = {
  leadNotes: [],
  //   lead_typs: [],
  isGetLeadNotesLoading: false,
  isCreateLeadNotesLoading: false,
  //   isUpdateLeadLoading: false,
  //   isDeleteLeadLoading: false,
  //   isGetLeadTypeLoading: false,
};

const leadNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_LEAD_NOTES_REQUEST:
      return {
        ...state,
        isGetLeadNotesLoading: true,
      };
    case constants.GET_LEAD_NOTES_SUCCESS:
      return {
        ...state,
        isGetLeadNotesLoading: false,
        leadNotes: Array.isArray(action.payload)
          ? action.payload
          : action.payload?.lead_notes || [],
      };
    case constants.GET_LEAD_NOTES_FAILURE:
      return {
        ...state,
        isGetLeadNotesLoading: false,
      };

    case constants.CREATE_LEAD_NOTES_REQUEST:
      return {
        ...state,
        isCreateLeadNotesLoading: true,
      };
    case constants.CREATE_LEAD_NOTES_SUCCESS:
      return {
        ...state,
        isCreateLeadNotesLoading: false,
      };
    case constants.CREATE_LEAD_NOTES_FAILURE:
      return {
        ...state,
        isCreateLeadNotesLoading: false,
      };

    // case constants.UPDATE_LEAD_REQUEST:
    //   return {
    //     ...state,
    //     isUpdateLeadLoading: true,
    //   };
    // case constants.UPDATE_LEAD_SUCCESS:
    //   return {
    //     ...state,
    //     isUpdateLeadLoading: false,
    //   };
    // case constants.UPDATE_LEAD_FAILURE:
    //   return {
    //     ...state,
    //     isUpdateLeadLoading: false,
    //   };

    // case constants.DELETE_LEAD_REQUEST:
    //   return {
    //     ...state,
    //     isDeleteLeadLoading: true,
    //   };
    // case constants.DELETE_LEAD_SUCCESS:
    //   return {
    //     ...state,
    //     isDeleteLeadLoading: false,
    //   };
    // case constants.DELETE_LEAD_FAILURE:
    //   return {
    //     ...state,
    //     isDeleteLeadLoading: false,
    //   };
    case "RESET_LEAD_NOTES":
      return {
        ...initialState,
        leadNotes: [],
      };

    default:
      return state;
  }
};
export default leadNotesReducer;
